import { mapState } from "vuex";
export const marketingIndexMixins = {
  computed: {
    marketingTopBarList() {
      let topbarList = [
          {
              name: "营销管理",
              isActive: false,
              path: "/marketing",
              childrenPath: [
                  "/marketing/order"
              ],
              icon:require("@/assets/img/menuIcons/icon-marketing.png")
          },
          {
              name: "我的订购",
              isActive: false,
              path: "/marketing/myorder",
              icon:require("@/assets/img/menuIcons/icon-marketingmyorder.png")
          },
      ];
      topbarList.forEach(val => {
          if (val.path == this.$route.path) {
              val.isActive = true;
          }
          if (val.childrenPath) {
              if (~val.childrenPath.indexOf(this.$route.path)) {
                  val.isActive = true;
              }
          }
      });
      return topbarList;
  }
  },
}
